import { render } from "./T_shirt_2_front.vue?vue&type=template&id=c8dc22f4"
import script from "./T_shirt_2_front.vue?vue&type=script&lang=js"
export * from "./T_shirt_2_front.vue?vue&type=script&lang=js"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__